module.exports = __webpack_public_path__ + "img/pinia.95bf21b3.svg";